import { Pipe, PipeTransform } from '@angular/core';
import { GridItem } from '../grid-control.model';
@Pipe({
  name: 'editorValidate'
})
export class EditorValidatePipe implements PipeTransform {
  private previous: Date;
  private delay = 1000; // Sau khoảng thời gian delay nếu không có thay đổi thì thì mới bắt đầu thực hiện validate
  async transform(value: string, item: GridItem, validate: (item: GridItem) => string | Promise<string>): Promise<boolean> {
    this.previous = new Date();
    await new Promise(resolve => setTimeout(resolve, this.delay));
    const now = new Date();
    const dif = now.getTime() - this.previous.getTime();
    if (dif < this.delay) {
      return true;
    }
    item.editorHandler = item.editorHandler || {};
    if (!validate) {
      item.editorHandler.errorMessage = null;
      return true;
    }
    const result = validate(item);
    if (result instanceof Promise) {
      item.editorHandler.errorMessage = await result;
      return true;
    } else {
      item.editorHandler.errorMessage = result;
      return true;
    }
  }
}
